import React from 'react';
import {
  FormControl
} from 'react-bootstrap';

import styles from './SearchBox.styles.js';
import {
  Search as SearchIcon,
  Times as TimesIcon,
} from '../icons/Icons.jsx';

// DO NOT MAKE THIS A STATELESS COMPONENT
// AutocompleteSearchBox uses a ref to render search suggestions.
class SearchBoxLayout extends React.Component {
  render() {
    let {value, onChange, onClear, ...rest} = this.props;
    return (
      <div
        style={styles.container}>
        <SearchIcon style={styles.searchIcon} />
        <FormControl
          style={styles.input}
          type="text"
          value={value}
          onChange={onChange}
          {...rest}
        />
        {
          value
            ? (
              <TimesIcon
                style={styles.clearIcon}
                onClick={onClear}
              />
            )
            : null
        }
      </div>
    );
  }
}

export default SearchBoxLayout;
